import React from 'react'

import styles from './cubit-checkbox.module.css'

import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox'

type CubitCheckboxProps = {
    checked: boolean
    indeterminate?: boolean
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onClick?: (e: React.MouseEvent) => void
}

export const CubitCheckbox: React.FC<CubitCheckboxProps> = (props) => {
    const { checked, indeterminate, onChange, onClick } = { ...props }

    const renderCheckboxIcon = (isChecked: boolean, isIndeterminate: boolean | undefined): any => {
        return isIndeterminate ? (
            <IndeterminateCheckBoxIcon />
        ) : isChecked ? (
            <CheckBoxIcon className={styles.checkboxSelected} />
        ) : (
            <CheckBoxOutlineBlankIcon />
        )
    }

    return (
        <div className={styles.checkbox}>
            {renderCheckboxIcon(checked, indeterminate)}
            <input
                checked={checked}
                className={styles.checkboxInput}
                onChange={onChange}
                onClick={onClick}
                type="checkbox"
            />
        </div>
    )
}
